/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, HostBinding, OnInit, inject } from '@angular/core';
import { CdPopupSize, MAT_DIALOG_DATA } from '../cd-popup.service';
import { CdsIconModule } from '@cds/ng-web-components/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatDialogContent, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-cd-popup',
  templateUrl: './cd-popup.component.html',
  styleUrls: ['./cd-popup.component.scss'],
  imports: [CdsIconModule, CdkScrollable, MatDialogContent],
})
export class CdPopupComponent implements OnInit {
  private data = inject(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<CdPopupComponent>>(MatDialogRef);

  size: CdPopupSize = CdPopupSize.SMALL;
  isShowClose = true;

  @HostBinding('class.cds-popup') isCdsPopup = true;

  @HostBinding('class.cds-popup-sm') get isSmall(): boolean {
    return this.size === CdPopupSize.SMALL;
  }
  @HostBinding('class.cds-popup-md') get isMedium(): boolean {
    return this.size === CdPopupSize.MEDIUM;
  }
  @HostBinding('class.cds-popup-lg') get isLarge(): boolean {
    return this.size === CdPopupSize.LARGE;
  }

  ngOnInit(): void {
    this.size = this.data.__cdsPopupSize;
    this.isShowClose = this.data.isShowClose;
  }

  close() {
    this.dialogRef.close();
  }
}
